var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.625 0C3.86875 0 3.25 0.61875 3.25 1.375V20.625C3.25 21.3813 3.86875 22 4.625 22H18.375C19.1313 22 19.75 21.3813 19.75 20.625V5.5L14.25 0H4.625Z",
    fill: "#E2E5E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 5.5H19.75L14.25 0V4.125C14.25 4.88125 14.8687 5.5 15.625 5.5Z",
    fill: "#B0B7BD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.75 9.625L15.625 5.5H19.75V9.625Z",
    fill: "#CAD1D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 17.875C17 18.2531 16.6906 18.5625 16.3125 18.5625H1.1875C0.809375 18.5625 0.5 18.2531 0.5 17.875V11C0.5 10.6219 0.809375 10.3125 1.1875 10.3125H16.3125C16.6906 10.3125 17 10.6219 17 11V17.875Z",
    fill: "#F15642"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.49609 13.026C3.49609 12.8445 3.63909 12.6465 3.86941 12.6465H5.13922C5.85422 12.6465 6.49772 13.125 6.49772 14.0421C6.49772 14.9111 5.85422 15.3951 5.13922 15.3951H4.22141V16.1211C4.22141 16.3631 4.06741 16.4999 3.86941 16.4999C3.68791 16.4999 3.49609 16.3631 3.49609 16.1211V13.026ZM4.22141 13.3388V14.7083H5.13922C5.50772 14.7083 5.79922 14.3831 5.79922 14.0421C5.79922 13.6578 5.50772 13.3388 5.13922 13.3388H4.22141Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.57481 16.5002C7.39331 16.5002 7.19531 16.4012 7.19531 16.1599V13.0373C7.19531 12.84 7.39331 12.6963 7.57481 12.6963H8.83362C11.3457 12.6963 11.2908 16.5002 8.88312 16.5002H7.57481ZM7.92131 13.3673V15.8299H8.83362C10.3179 15.8299 10.3839 13.3673 8.83362 13.3673H7.92131Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.184 13.411V14.2848H13.5858C13.7838 14.2848 13.9818 14.4828 13.9818 14.6746C13.9818 14.8561 13.7838 15.0046 13.5858 15.0046H12.184V16.1589C12.184 16.3514 12.0472 16.4993 11.8547 16.4993C11.6127 16.4993 11.4648 16.3514 11.4648 16.1589V13.0363C11.4648 12.839 11.6133 12.6953 11.8547 12.6953H13.7845C14.0265 12.6953 14.1695 12.839 14.1695 13.0363C14.1695 13.2123 14.0265 13.4103 13.7845 13.4103H12.184V13.411Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3125 18.5625H3.25V19.25H16.3125C16.6906 19.25 17 18.9406 17 18.5625V17.875C17 18.2531 16.6906 18.5625 16.3125 18.5625Z",
    fill: "#CAD1D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.6fb55aa0c1398ef1205494b43594ca72.svg";
export { ForwardRef as ReactComponent };